import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store, { MutationName } from '@/store/index'
import { LeftType, Title } from '@/enums/header'

export const routes: Array<RouteRecordRaw> = [
  {
    name: 'Login',
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  {
    path: '/ui-sandbox',
    component: () => import(/* webpackChunkName: "uiSandbox" */ '@/views/UISandbox.vue'),
    meta: {
      requiresBottomNavigation: true,
    },
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "main" */ '@/views/Main.vue'),
    meta: {
      requiresBottomNavigation: true,
    },
    children: [
      {
        path: 'bring-in',
        component: () => import(/* webpackChunkName: "bring-in" */ '@/views/BringIn.vue'),
      },
      {
        path: 'search',
        component: () => import(/* webpackChunkName: "search" */ '@/views/Search.vue'),
        meta: {
          header: {
            title: Title.SEARCH,
            show: true,
            leftType: LeftType.DEFAULT,
          },
        },
      },
      {
        name: 'Profile',
        path: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
      },
      {
        name: 'MyWork',
        path: '/profile/my-work',
        component: () => import(/* webpackChunkName: "my-work" */ '@/views/MyWork.vue'),
        meta: {
          header: {
            title: Title.MY_WORK_STATUS,
            show: true,
            leftType: LeftType.BACK,
          },
        },
      },
      {
        name: 'MembersWork',
        path: '/profile/members-work',
        component: () => import(/* webpackChunkName: "members-work" */ '@/views/MembersWork.vue'),
        meta: {
          header: {
            title: Title.MEMBER_WORK_STATUS,
            show: true,
            leftType: LeftType.BACK,
          },
        },
      },
      {
        path: '/qr-scan',
        component: () => import(/* webpackChunkName: "qr-scan" */ '@/views/QrScan.vue'),
      },
      {
        name: 'FushidaDisconnectError',
        path: '/fushida-disconnect-error',
        component: () => import(/* webpackChunkName: "fushida-disconnect-error" */ '@/views/FushidaDisconnectError.vue'),
      },
    ],
  },
]

const router = createRouter({
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash }
    }
    return { top: 0, left: 0 }
  },
  routes,
  history: createWebHistory(process.env.BASE_URL),
})

router.beforeEach((to, from, next) => {
  let getHeader
  to.matched.forEach((record) => {
    getHeader = record.meta.header
  })
  store.commit(MutationName.SET_HEADER, getHeader)
  return next()
})

export default router
